/* eslint-disable class-methods-use-this */
import React from 'react'
import { connect } from 'react-redux'

import {
    CircularProgress,
    FormControlLabel,
    Switch,
    Tooltip,
} from '@material-ui/core'

import { CopyToClipboard } from 'react-copy-to-clipboard'
import { updateSubscription, updateInterestStatus } from '../actions'

import './index.scss'

class UserDetails extends React.PureComponent {
    constructor() {
        super()

        this.state = {
            convoData: {},
            copied: false,
        }

        this.updateInterestStatus = this.updateInterestStatus.bind(this)
        this.updateSubscription = this.updateSubscription.bind(this)
    }

    componentDidMount() {
        this.updateUserDetails()
    }

    componentDidUpdate(oldProps) {
        const { historicalDialogueLoading } = this.props

        if (oldProps.historicalDialogueLoading && !historicalDialogueLoading) {
            this.updateUserDetails()
        }
    }

    // Get data from current conversation
    updateUserDetails() {
        const { historicalDialogueLoading, historicalDialogue } = this.props

        if (historicalDialogueLoading || !historicalDialogue) {
            return
        }

        const [firstMessage] = historicalDialogue

        const {
            AccountId, Name, Surname, UserId, Phone
        } = firstMessage

        const convoData = {
            AccountId,
            Name,
            Surname,
            UserId,
            Phone,
        }

        // this.setState({ convoData })
        return convoData
    }

    updateInterestStatus() {
        const { userDetails, historicalDialogue } = this.props
        const { InterestStatus } = userDetails

        const [firstMessage] = historicalDialogue

        const {
            AccountId: accountId,
            UserId: userId,
            ThreadId: threadId,
        } = firstMessage

        let { ConversationId: convoId } = firstMessage

        if (!convoId) {
            convoId = `${accountId}/${userId}/${threadId}`
        }

        const status = !InterestStatus

        const payload = {
            convoId,
            status,
        }

        this.props.updateInterestStatus(payload)
    }

    updateSubscription(channel) {
        const { historicalDialogue, subscriptionStatuses } = this.props
        const lastMessage = historicalDialogue[historicalDialogue.length - 1]
        const { AccountId, Email, Phone } = lastMessage

        const [emailsub, smssub] = subscriptionStatuses || []

        let userIdToPost = ''
        let unsubscribe = 0
        if (channel === 'email') {
            unsubscribe = !emailsub.Unsubscribed
            userIdToPost = Email
        }
        if (channel === 'sms') {
            unsubscribe = !smssub.Unsubscribed
            userIdToPost = Phone
        }

        this.props.updateSubscription({
            unsubscribe,
            accountId: AccountId,
            userId: userIdToPost,
        })
    }

    formatPhoneNumber(phoneNumberString) {
        const cleaned = ('' + phoneNumberString).replace(/\D/g, '')
        const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
        if (match) {
            // const intlCode = match[1] ? '+1 ' : ''
            return [
                // intlCode,
                '(',
                match[2],
                ') ',
                match[3],
                ' ',
                match[4],
            ].join('')
        }
        return phoneNumberString
    }

    formatIrishPhone(value) {
        let digitsOnly
        if (value && value.includes('+353')) {
            digitsOnly = value.replace(/\D/g, '')
            if (digitsOnly.length >= 10) {
                return `(0${digitsOnly.slice(3, 5)}) ${digitsOnly.slice(
                    5,
                    8
                )} ${digitsOnly.slice(8)}`
            }
            return value
        }
        digitsOnly = value.replace(/\D/g, '')
        if (digitsOnly.length >= 10) {
            return `(${digitsOnly.slice(-10, -7)}) ${digitsOnly.slice(
                -7,
                -4
            )} ${digitsOnly.slice(-4)}`
        }
        return value
    }

    formatPhone(phone) {
        if (!phone || phone.length < 3) {
            return phone
        }

        if (phone.includes('+353')) {
            return this.formatIrishPhone(phone)
        }

        return this.formatPhoneNumber(phone)
    }

    onCopy(target) {
        this.setState({ copied: target })
        setTimeout(() => {
            this.setState({ copied: null })
        }, 3000)
    }

    render() {
        // const { convoData } = this.state
        const convoData = this.updateUserDetails()

        const {
            userDetailsLoading,
            userDetails,
            subscriptionStatuses,
            historicalDialogue,
        } = this.props

        console.log('historicalDialogue', historicalDialogue)
        const lastMessage = historicalDialogue?.length
            ? historicalDialogue[historicalDialogue.length - 1]
            : {}

        const [subscriptionEmail, subscriptionSms] = subscriptionStatuses || []

        return (
            <div className='UserDetails'>
                {userDetailsLoading && (
                    <div className='loading-wrapper'>
                        <CircularProgress size={30} />
                    </div>
                )}
                {!userDetailsLoading && userDetails && convoData.UserId && (
                    <React.Fragment>
                        <div className='Details__row'>
                            <p>Name</p>
                            <p>{convoData.Name}</p>
                        </div>
                        <div className='Details__row'>
                            <p>Surname</p>
                            <p>{convoData.Surname}</p>
                        </div>
                        <div className='Details__row'>
                            <p>
                                Identificator
                                {this.state.copied === 'identificator' && (
                                    <span className='copied'>
                                        Copied &#10003;
                                    </span>
                                )}
                            </p>
                            <CopyToClipboard
                                text={this.formatPhone(convoData.UserId)}
                                onCopy={() => this.onCopy('identificator')}
                            >
                                <p className='copyable'>
                                    <Tooltip
                                        title='click to copy'
                                        placement='bottom'
                                    >
                                        <span>
                                            {this.formatPhone(convoData.UserId)}
                                        </span>
                                    </Tooltip>
                                </p>
                            </CopyToClipboard>
                        </div>
                        <div className='Details__row'>
                            <p>
                                Phone
                                {this.state.copied === 'phone' && (
                                    <span className='copied'>
                                        Copied &#10003;
                                    </span>
                                )}
                            </p>
                            <CopyToClipboard
                                text={this.formatPhone(convoData.Phone)}
                                onCopy={() => this.onCopy('phone')}
                            >
                                <p className='copyable'>
                                    <Tooltip
                                        title='click to copy'
                                        placement='bottom'
                                    >
                                        <span>
                                            {this.formatPhone(convoData.Phone)}
                                        </span>
                                    </Tooltip>
                                </p>
                            </CopyToClipboard>
                        </div>
                        <div className='Details__row'>
                            <p>Unsubscribe email</p>
                            <p>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={Boolean(
                                                subscriptionEmail?.Unsubscribed
                                            )}
                                            onChange={() => this.updateSubscription('email')
                                            }
                                            size='small'
                                            color='primary'
                                            disabled={lastMessage.Email === '-'}
                                        />
                                    }
                                    // disabled
                                />
                            </p>
                        </div>
                        <div className='Details__row'>
                            <p>Unsubscribe sms</p>
                            <p>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={Boolean(
                                                subscriptionSms?.Unsubscribed
                                            )}
                                            onChange={() => this.updateSubscription('sms')
                                            }
                                            size='small'
                                            color='primary'
                                            disabled={lastMessage.Phone === '-'}
                                        />
                                    }
                                />
                            </p>
                        </div>
                        <div className='Details__row'>
                            <p>No longer interested</p>
                            <p>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={
                                                !userDetails.InterestStatus
                                            }
                                            onChange={this.updateInterestStatus}
                                            size='small'
                                            color='primary'
                                        />
                                    }
                                />
                            </p>
                        </div>
                    </React.Fragment>
                )}
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { historicalDialogueLoading, historicalDialogue } = state.operatorDashboard

    const { userDetailsLoading, userDetails, subscriptionStatuses } = state.operatorDashboardDetails

    return {
        historicalDialogueLoading,
        historicalDialogue,
        userDetailsLoading,
        userDetails,
        subscriptionStatuses,
    }
}

export default connect(mapStateToProps, {
    updateSubscription,
    updateInterestStatus,
})(UserDetails)
